import React from "react";
import Loader from "react-loaders";
import { useSelector } from "react-redux";
import { Roles } from "../../utils/Roles";
import "./Loading.scss";

/**
 * Global loader.
 * Student/parent: same blue arc spinner used in Messages.
 * Other roles: existing ball-clip-rotate with primary color.
 */
function Loading({ inline = false }) {
  const userRole = useSelector((state) => state.UserReducer?.userObj?.role);
  const isBlueLoader =
    userRole === Roles.STUDENT_NAME || userRole === Roles.PARENT_NAME;

  const className = [
    "loader-container",
    inline ? "loader-inline" : "",
    isBlueLoader ? "loader-blue" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={className}>
      <div className="loader-container-inner">
        <div className="text-center">
          {isBlueLoader ? (
            <div className="msg-style-loader" aria-label="Loading" />
          ) : (
            <Loader type="ball-clip-rotate" className="customLoader" />
          )}
        </div>
      </div>
    </div>
  );
}

export default Loading;
